import { useEffect } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useTag, { useTagForm } from '@hooks/useTag'

import type { TagModel } from '@models/types'

const defaultState = {
  showImage: false,
}

// @ts-expect-error TS1015
function useCreateOrEditTagModal(tag?: TagModel = {}) {
  const [state, setState] = useSetState(defaultState)
  const { showImage } = state

  const currentUserPayload = useCurrentUser()
  const { isBrandUser } = currentUserPayload

  const formPayload = useTagForm(tag, { validateOn: 'change' })

  const {
    callbacks,
    creating,
    updating,
  } = useTag(tag)

  const imageUrl = digObject(tag, 'image.preserved_560x560', '')

  useEffect(() => {
    if ((imageUrl)){
      setState({ showImage: true })
    } else {
      setState({ showImage: false })
    }
  }, [tag.id])

  return {
    callbacks: {
      setState,
      ...callbacks,
    },
    formPayload,
    imageUrl,
    isBrandUser,
    loading: creating || updating,
    showImage,
  }
}

export default useCreateOrEditTagModal
